import React from 'react';

import CustomModal from 'components/shared/CustomModal';

import AlertsTable from './AlertsTable';
import EnhancedTableToolbar from './EnhancedTableToolbar';

interface Props {
  open: boolean;
  handleClose: () => void;
}

const AlertsModal = ({ open, handleClose }: Props) => {
  return (
    <CustomModal
      open={open}
      showCloseIcon
      handleClose={handleClose}
      title={'Alertas'}
      sxContent={{ overflowY: 'hidden', paddingTop: 0 }}
    >
      <EnhancedTableToolbar />
      <AlertsTable />
    </CustomModal>
  );
};

export default AlertsModal;
